import { gql, TypedDocumentNode } from '@apollo/client';

import { HistoryConnection, HistoryConnectionInput } from '@atom/types/history';

export const GET_HISTORY: TypedDocumentNode<
  { history: HistoryConnection },
  { input: HistoryConnectionInput }
> = gql`
  query history($input: HistoryConnectionInput!) {
    history(input: $input) {
      totalCount
      history {
        id
        subjectId
        date
        message
        device
        user {
          id
          firstName
          lastName
          photoUrl
        }
      }
    }
  }
`;
